import api from 'Application/api/api';

const getAllMeasureTasks = (cancelToken = null) =>
    api.get('/measures/tasks', { cancelToken });

export default getAllMeasureTasks;
